import React from "react";

const Footer = () => (
  <footer>
    <div className="row-container">
      <div className="footer-text">𒀝𒅗𒁺𒌑</div>
    </div>
  </footer>
);

export default Footer;
